import axios, { AxiosRequestConfig } from 'axios';
import { isEmpty } from 'lodash';
import { LAGER_API_HOST } from '../constants/api';

export default function request<ResponseDataType>(options: AxiosRequestConfig) {
  if (isEmpty(options.baseURL) && options.url) options.baseURL = LAGER_API_HOST;
  return axios.request<ResponseDataType>(options);
}
